module.exports = new __parcel__URL__("SearchError.27457269.svg").toString();